import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import StepperNative from "./stepper.native";
import deviceService from "./services/device.service";

const StepperContainer = () => {
  const history = useHistory();
  const [atualItem, setAtualItem] = useState<number>(0);

  const os = deviceService.getUserOperationalSystem();

  const photos = deviceService.getPhotosBySystem(os);

  const photo: string = photos[atualItem];

  const onClickItem = (index: number) => {
    setAtualItem(index);
  }

  const handleNext = () => {
    if (atualItem === 2) {
      skipTutorial();
    }

    setAtualItem(atualItem + 1);
  }

  const skipTutorial = () => {
    localStorage.setItem('haveSeenTutorial', JSON.stringify(true));
    history.push('/login');
  }

  return (
    <StepperNative
      photo={photo}
      photos={photos}
      atualItem={atualItem}
      handleNext={handleNext}
      changeIndex={onClickItem}
      skipTutorial={skipTutorial}
      data-testid={`stepper-${atualItem}`}
    />
  );
}

export default StepperContainer;
